import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyUs() {
  const {
    scrollY
  } = useScroll();
  const [isDesktop, setIsDesktop] = useState(false);
  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= 1024);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  const rawY = useTransform(scrollY, [0, 2000], [0, -100]);
  const y = isDesktop ? rawY : 0;
  const benefits = ['Led by Rigo, a certified bilingual arborist', 'We remove dangerous weight before storms hit', 'Clean results, we haul everything away', 'Trusted by homeowners and commercial properties across the Valley'];
  return <section id="about" className="w-full bg-zinc-900 py-16 md:py-24 overflow-hidden" data-id="element-145">
      <div className="container mx-auto px-6" data-id="element-146">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-148">
            <h2 className="font-display text-3xl md:text-5xl text-white mb-8" data-id="element-149">
              Safety. Skill. Integrity.
            </h2>
            <div className="space-y-4" data-id="element-150">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-start gap-3" data-id="element-151">
                  <CheckCircle2 className="w-6 h-6 text-brand-green flex-shrink-0 mt-1" data-id="element-152" />
                  <p className="font-body text-white/90 text-lg" data-id="element-153">{benefit}</p>
                </motion.div>)}
            </div>
          </motion.div>

          <motion.div style={{
          y
        }} className="relative aspect-[3/4] w-full max-w-md mx-auto rounded-lg overflow-hidden" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/aadg8BVbQXQUvztJtn5b9h/richard-burlton-eaf5cOAt66g-unsplash.jpg" alt="Roped arborist cutting a large limb with a chainsaw high in a tree" className="w-full h-full object-cover" data-id="element-155" />
          </motion.div>
        </div>
      </div>
    </section>;
}